/*
 * @Author: van
 * @Date: 2021-07-26 17:07:26
 * @LastEditors: van
 * @LastEditTime: 2021-09-29 18:01:30
 */
/**
 * tab点击循环menulist获取menu_id的递归
 */
import store from "@/store/store";
const tabRecursion = (_target, list) => {
    for (let i in list) {
        if (_target == list[i].url) {
            store.commit("MENUBREAD", [list[i].parent_name,list[i].name])
            return list[i].id;
        } else if (list[i].child && list[i].child.length) {
            let func = tabRecursion(_target, list[i].child);
            if (func) {
                return func;
            }
        }
    }
    return "";
};
export default tabRecursion;
